import { render, staticRenderFns } from "./Reportes.vue?vue&type=template&id=28b9f751&scoped=true"
import script from "./Reportes.vue?vue&type=script&lang=js"
export * from "./Reportes.vue?vue&type=script&lang=js"
import style0 from "./Reportes.vue?vue&type=style&index=0&id=28b9f751&prod&scoped=true&lang=css"
import style1 from "./Reportes.vue?vue&type=style&index=1&id=28b9f751&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b9f751",
  null
  
)

export default component.exports